import { createSlice } from "@reduxjs/toolkit";
import { SyncJobRun } from "./SyncJobRun";
import { fetchSyncJobRuns } from "./syncJobsApi";
import { RootState } from "../../app/store";

interface SyncJobsState {
  syncJobRuns: SyncJobRun[];
  status: "idle" | "loading" | "failed";
}

const initialState: SyncJobsState = {
  syncJobRuns: [],
  status: "idle",
};

const syncJobsSlice = createSlice({
  name: "syncJobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSyncJobRuns.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSyncJobRuns.fulfilled, (state, action) => {
        state.syncJobRuns = action.payload;
        state.status = "idle";
      })
      .addCase(fetchSyncJobRuns.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const selectSyncJobRuns = (state: RootState) =>
  state.syncJobs.syncJobRuns;

export const selectSyncJobsLoading = (state: RootState) =>
  state.syncJobs.status === "loading";

export default syncJobsSlice.reducer;
